import React, {useState} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Container from "@material-ui/core/Container";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AdminListFloorPlans from "./AdminListFloorPlans";
import AdminEmailOptions from "../components/AdminEmailOptions";
import ListLeads from "./ListLeads";

function AdminOptions() {
    const [tab, setTab] = useState('floor-plans');
    return (
        <Container maxWidth="lg">
            <AppBar position="static" color="default" style={{backgroundColor: '#fff'}}>
                <Tabs aria-label="admin options" value={tab} onChange={(_, value) => setTab(value)}>
                    <Tab label="Floor Plans" value="floor-plans"/>
                    <Tab label="Leads" value="leads"/>
                    <Tab label="Options" value="options"/>
                </Tabs>
            </AppBar>
            {tab === 'floor-plans' ? <AdminListFloorPlans/> : null}
            {tab === 'leads' ? <ListLeads/> : null}
            {tab === 'options' ? <AdminEmailOptions/> : null}
        </Container>
    );
}

export default AdminOptions;